import { useDailyUsage, useDailyIntervalParams } from "./interval";
import clsx from "clsx";
import { useScaffold } from "@Light/scaffold";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

export type DailySelectorProps = {};

export const DailySelector: React.FC<DailySelectorProps> = ({}) => {
  const scaffold = useScaffold();
  const { selectedMonth } = useDailyIntervalParams();
  const dailyUsage = useDailyUsage();

  const prevMonth = selectedMonth.subtract(1, "month");
  const nextMonth = selectedMonth.add(1, "month");

  const prevLink = `/dash/usage?${new URLSearchParams({
    month: `${prevMonth.month() + 1}`,
    year: `${prevMonth.year()}`,
    mode: "month",
  })}`;
  const nextLink = `/dash/usage?${new URLSearchParams({
    month: `${nextMonth.month() + 1}`,
    year: `${nextMonth.year()}`,
    mode: "month",
  })}`;

  const hasPrev = dailyUsage.isSuccess && Boolean(dailyUsage.data.previous);
  const hasNext = dailyUsage.isSuccess && Boolean(dailyUsage.data.next);

  const Link = scaffold.system.link;
  return (
    <div className="flex flex-row justify-between items-center p-2">
      <div className="w-6 h-6">
        {hasPrev && (
          <Link to={prevLink}>
            <ChevronLeftIcon />
          </Link>
        )}
      </div>
      <div className={clsx("text-lg", scaffold.page.colors.text.secondary)}>
        {selectedMonth.format("MMMM YYYY")}
      </div>
      <div className="w-6 h-6">
        {hasNext && (
          <Link to={nextLink}>
            <ChevronRightIcon />
          </Link>
        )}
      </div>
    </div>
  );
};
